import React from "react";
import style from "./style.module.scss";
import Row from "./row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";

const CardSummaryTable = ({ data = [], loading }) => {
  const tableData = Array.isArray(data) ? data : [];
  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            {/* <th className={style.header_cell}></th> */}
            <th className={style.header_cell} style={{ width: "250px" }}>
              Card Type
            </th>
            <th className={style.header_cell}>Code</th>
            <th className={style.header_cell}>Transaction Count</th>
            <th className={style.header_cell}>Total</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={4}
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="4" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => <Row data={row} key={index} />)
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CardSummaryTable;
